module.exports = __webpack_public_path__ + "img/jincheng1.75f9a5ad.png";